/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Users
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 20Sep2022 craig File created.
 \******************************************************************************/
import React, {Fragment, useMemo, useState} from "react";
import {IUser} from "../../../models/user/IUser";
import {Button, Col, Container, Row} from "react-bootstrap";
import {AppTable} from "../../../components/AppTable";
import {useRequest} from "../../../helper/useRequest";

export const Users: React.FC = () => {
    const [users, setUsers] = useState<IUser[]>([]);

    const usersURL = process.env.REACT_APP_API_URL + "/api/admin/users";
    const [requestState, getUsersData] = useRequest({url: usersURL, initialIsLoading: true,})
    const {isLoading, data, error} = requestState;

    useMemo(() => {
        getUsersData();
    }, [])

    useMemo(() => {
        if (data != null) {
            setUsers(data);
        }
    },[data])

    const buildUsersData = () => {
        return (
            <Container className="form-container" fluid>
                <Row id={"admin-users-title"}>
                    <Col className="page-title">
                        <h1>Admin - Users</h1>
                    </Col>
                </Row>
                <Row id={"gs-users-title"} className={"section-two"}>
                    <Col className={"section-header"}>
                        <h3>Gold Standard Users</h3>
                    </Col>
                </Row>
                <Row id={"users-header"} className={"section-data-header"}>
                    <Col>Name</Col>
                    <Col>Username</Col>
                    <Col>Role</Col>
                    <Col></Col>
                </Row>
                <Row id={"users-list"}>
                    {users?.map((user: IUser) => (
                        <Container key={"user-" + user.UserID.toString()} className={"user-row"}>
                            <Row key={user.UserID.toString()}>
                                <Col id={"name-" + user.UserID.toString()}>{user.FirstName + " " + user.LastName}</Col>
                                <Col id={"email-" + user.UserID.toString()}>{user.EmailAddress}</Col>
                                <Col id={"role-" + user.UserID.toString()}>{user.Role.Role}</Col>
                                <Col id={"edit-" + user.UserID.toString()}><Button href={"/admin/user/" + user.UserID}
                                             variant={"link"}>{'Edit'}</Button></Col>

                            </Row>
                            {AppTable(user.TeamUserLinkage)}
                        </Container>
                    ))}
                </Row>
                <Row id={"add-user-btn"}>
                    <Col>
                        <Button variant="primary" className="btn-submit" type="button" href={"/admin/user"}>
                            Add User
                        </Button>
                    </Col>
                </Row>
            </Container>
        )
    }

    return (
        <Fragment>
            {isLoading && <p>Loading ...</p>}
            {error && <p>Error</p>}
            {data && buildUsersData()}
        </Fragment>
    );
}